import _ from 'lodash';
import { computed, makeObservable, observable } from 'mobx';
import { AgtAkumaPrimeUiStore, AgtAkumaPrimeKwVM, IAkumaPrimeProps } from './agt.akumaprime.ui.store';

export class BnrAkumaPrimeKwVM implements IAkumaPrimeProps {
	constructor(items: AgtAkumaPrimeKwVM[]) {
		if (items.length > 0) {
			this.kw = items[0].kw;
		} else {
			this.kw = 0;
		}

		// Calculate averages from items
		this.einordnungSach = _.sumBy(items, 'einordnungSach');
		this.einordnungLeben = _.sumBy(items, 'einordnungLeben');
		this.einordnungKranken = _.sumBy(items, 'einordnungKranken');
		this.einordnungSonstige = _.sumBy(items, 'einordnungSonstige');
		this.einordnungFonds = _.sumBy(items, 'einordnungFonds');
		this.einordnungNichtKontaktieren = _.sumBy(items, 'einordnungNichtKontaktieren');
		this.einordnungNichtEingeordnet = _.sumBy(items, 'einordnungNichtEingeordnet');
		this.einordnungBestehendeAktion = _.sumBy(items, 'einordnungBestehendeAktion');

		this.beziehungWenigerGut = _.sumBy(items, 'beziehungWenigerGut');
		this.beziehungGut = _.sumBy(items, 'beziehungGut');
		this.beziehungMittel = _.sumBy(items, 'beziehungMittel');
		this.beziehungUnbekannt = _.sumBy(items, 'beziehungUnbekannt');

		this.terminierungExternTotal = _.sumBy(items, 'terminierungExternTotal');
		this.terminierungAgentur = _.sumBy(items, 'terminierungAgentur');
	}

	einordnungSach: number;
	einordnungLeben: number;
	einordnungKranken: number;
	einordnungSonstige: number;
	einordnungFonds: number;
	einordnungNichtKontaktieren: number;
	einordnungNichtEingeordnet: number;
	einordnungBestehendeAktion: number;

	einordnungsQuote: number = 0;

	beziehungWenigerGut: number;
	beziehungGut: number;
	beziehungMittel: number;
	beziehungUnbekannt: number;

	terminierungExternTotal: number;
	terminierungAgentur: number;

	kw: number;
}

export class BnrAkumaPrimeUiStore {
	agtAkumaPrimeUiStore: AgtAkumaPrimeUiStore;
	constructor(agtAkumaPrimeUiStore: AgtAkumaPrimeUiStore) {
		makeObservable(this);
		this.agtAkumaPrimeUiStore = agtAkumaPrimeUiStore;
	}

	@observable
	items: AgtAkumaPrimeKwVM[] = [];

	calc() {
		const count = this.items.length;
		if (count === 0) {
			return;
		}

		this.einordnungsQuoteAvg = this.calcAvgByPath('einordnungsQuote');
		this.einordnungsQuoteAvgNot = 100 - this.einordnungsQuoteAvg;

		this.avg = new BnrAkumaPrimeKwVM(this.items);
	}

	calcAvgByPath(p: string) {
		const items = this.items;
		const count = items.length;
		const sum = _.sumBy(items, p);
		return sum / count;
	}

	@observable
	avg: BnrAkumaPrimeKwVM = new BnrAkumaPrimeKwVM([]);

	@observable
	einordnungsQuoteAvg: number = 0;

	@observable
	einordnungsQuoteAvgNot: number = 100;
}
